import { defaultOptions, FOCUS_VISIBLE_ATTR, FOCUS_WITHIN_ATTR } from './constants';
/**
 * Creates a style for @see makeStyles that includes the necessary selectors for focus.
 * Should be used only when @see createFocusOutlineStyle does not fit requirements
 *
 * @param style - styling applied on focus, defaults to @see getDefaultFocusOutlineStyles
 * @param options - Configure the style of the focus outline
 */ export function createCustomFocusIndicatorStyle(style, { selector =defaultOptions.selector  } = defaultOptions) {
    return {
        ...selector === 'focus' && {
            [`&[${FOCUS_VISIBLE_ATTR}]`]: style
        },
        ...selector === 'focus-within' && {
            [`&[${FOCUS_WITHIN_ATTR}]:${selector}`]: style
        }
    };
}
